import React, { useEffect, useState } from "react";

import { instanceToken } from "../../../utils/constant";
import { useNavigate, Link } from "react-router-dom";
import {
  Breadcrumbs,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  TablePagination,
  Avatar,
} from "@mui/material";
import faqService from "../../../services/faqService";

export default function FAQs() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    fetchEmergencies(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchEmergencies = async (limit, offset) => {
    try {
      const res = await faqService.getAllFaqs(
        instanceToken.token,
        limit,
        offset
      );
      console.log(res);
      parse(res.data);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    setFaqs(data.faqs);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  if (!faqs) {
    return <em>Loading</em>;
  }

  return (
    <>
      <div role="presentation" style={{ marginBlockEnd: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <span>FAQs</span>
        </Breadcrumbs>
      </div>

      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          sx={{ my: 3 }}
          onClick={() => navigate("/faqs/create-faq")}
        >
          Create
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple-table">
          <TableHead>
            <TableRow className="thead">
              <TableCell>ID</TableCell>
              {/* <TableCell>Image</TableCell> */}
              <TableCell>Category Eng</TableCell>
              <TableCell>Category MM</TableCell>
              <TableCell>Question En</TableCell>
              <TableCell>Question MM</TableCell>
              <TableCell>Number Of Answer</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {faqs.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>

                <TableCell>{row.category_en}</TableCell>
                <TableCell>{row.category_mm}</TableCell>
                <TableCell>{row.question_en}</TableCell>
                <TableCell>{row.question_mm}</TableCell>
                <TableCell>{row.answers.length}</TableCell>
                <TableCell>
                  <Button
                    size="small"
                    component={Link}
                    color="secondary"
                    to={`/faqs/${row.id}`}
                  >
                    Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
}
